// extracted by mini-css-extract-plugin
export var adjacentSlide = "_ne-9";
export var arrowButtonContainer = "_ne-5";
export var arrowButtonIcon = "_ne-6";
export var carouselArrowButton = "_ne-2";
export var carouselElementContainer = "_ne-1";
export var currentSlide = "_ne-8";
export var left = "_ne-3";
export var otherSlide = "_ne-a";
export var productCarouselContainer = "_ne-0";
export var right = "_ne-4";
export var sliderOverflow = "_ne-7";